'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { FESTIVAL_MONTH_OPTIONS } from '../constants';
interface FilterMonthGridProps {
  selectedMonth: number | null;
  onSelectMonth: (month: number | null) => void;
}
export function FilterMonthGrid(t0) {
  const $ = _c(5);
  const {
    selectedMonth,
    onSelectMonth
  } = t0;
  let t1;
  if ($[0] !== onSelectMonth || $[1] !== selectedMonth) {
    t1 = FESTIVAL_MONTH_OPTIONS.map(option => {
      const isSelected = selectedMonth === option.value;
      return <button key={option.value} type="button" aria-pressed={isSelected} onClick={() => onSelectMonth(isSelected ? null : option.value)} className={cn("flex aspect-square items-center justify-center rounded-pill transition-colors duration-150 typo-caption1", isSelected ? "bg-B-50 font-600 text-B-600" : "font-500 text-Gray-700 hover:bg-Gray-50")}>{option.label}</button>;
    });
    $[0] = onSelectMonth;
    $[1] = selectedMonth;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="grid grid-cols-3 gap-4">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}